import { createItemsData } from '../utils/request-utils'
import { Service } from './base-service'
import { HALApiService } from './hal-api.service'

export const dsRatesService = new Service('/delivery-services/rates', HALApiService, createItemsData)
